import React from "react";
import { RCCGrid } from "react-common-components";
import { v4 } from "uuid";
import SortableItem from "src/components/Sortable/Item";
import SortableContainerWithoutContext from "src/components/Sortable/ContainerWithoutContext";
import { verticalListSortingStrategy } from "src/components/Sortable/Container/strategy";
import { IMetba002, IPerspestiveList } from "./interface";
import Perspective from "./perspective";

const PerspectiveList: React.FC<IPerspestiveList> = ({
	perspectives
}) => (
	<RCCGrid container>
		<SortableContainerWithoutContext
			items={perspectives}
			strategy={verticalListSortingStrategy}
		>
			{perspectives && perspectives.map((perspective: IMetba002) => (
				<SortableItem id={`p-${perspective.id}`} key={v4()}>
					<RCCGrid>
						<Perspective 
							perspective={perspective}
						/>
					</RCCGrid>
				</SortableItem>
			))}
		</SortableContainerWithoutContext>
	</RCCGrid>
);

export default PerspectiveList;
